import type { LoadOptionsLimit, Translations } from './types.ts';

export const DEFAULT_OVERFLOW_LIMIT = 5;
export const DEFAULT_LOAD_DEBOUNCE = 300;
export const DEFAULT_STATIC_SEARCH_DEBOUNCE = 150;

export const DEFAULT_SEARCH_LIMIT: LoadOptionsLimit = {
  MIN: 1000,
  MAX: 2147483647,
};

export const COMMA = ',';
export const INLINE_VALUE_DELIMITER = `${COMMA} `;

export const DEFAULT_TRANSLATIONS: Required<Translations> = {
  selection: 'Selection',
  selected: 'Selected',
  selectAll: 'Select all',
  clearAll: 'Clear all',
  searchSelection: 'Search in selection',
  searchSelected: 'Search in selected',
  total: 'Total',
  totalSeparator: 'of',
  toggleSelection: 'Toggle selection type',
  noEntries: 'There are no entries',
};
